import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import React from "react";

interface Loader3DProps {
  cardSize: number;
}

const Container = styled(Box, {
  shouldForwardProp: (prop) => prop !== "cardSize",
})<Loader3DProps>(({ cardSize }) => ({
  "--size": `${cardSize / 4}px`,
  display: "grid",
  placeItems: "center",
  perspective: "1000px",
  perspectiveOrigin: "100% 100%",
  width: "var(--size)",
  height: "var(--size)",
}));

const Cube = styled(Box, {
  shouldForwardProp: (prop) => prop !== "cardSize",
})<Loader3DProps>(({ cardSize }) => ({
  "--size": `${cardSize / 4}px`,
  position: "relative",
  width: "var(--size)",
  height: "var(--size)",
  transformStyle: "preserve-3d",
  animation: "rotate 6s linear infinite",
  "@keyframes rotate": {
    "100%": { transform: "rotateX(0deg) rotateY(360deg) rotateZ(360deg)" },
  },
}));

const CubeFace = styled(Box, {
  shouldForwardProp: (prop) => prop !== "cardSize" && prop !== "faceIndex",
})<{
  faceIndex: number;
  cardSize: number;
}>(({ faceIndex, cardSize }) => {
  const faceSize = `${cardSize / 10}px`;
  const transforms = [
    `translateZ(${faceSize})`,
    `rotateY(90deg) translateZ(${faceSize})`,
    `rotateY(180deg) translateZ(${faceSize})`,
    `rotateX(90deg) translateZ(${faceSize})`,
    `rotateY(-90deg) translateZ(${faceSize})`,
    `rotateX(-90deg) translateZ(${faceSize}) rotate(180deg)`,
  ];

  return {
    "--face-size": `${cardSize / 5}px`,
    position: "absolute",
    width: "var(--face-size)",
    height: "var(--face-size)",
    background: "#191A23",
    border: `${cardSize * 0.01}px solid white`,
    transform: transforms[faceIndex],
  };
});

export const Loader3D: React.FC<Loader3DProps> = ({ cardSize }) => {
  const faces = Array.from({ length: 6 }, (_, i) => i);

  return (
    <Container cardSize={cardSize}>
      <Cube cardSize={cardSize}>
        {faces.map((faceIndex) => (
          <CubeFace key={faceIndex} faceIndex={faceIndex} cardSize={cardSize} />
        ))}
      </Cube>
    </Container>
  );
};
